import { FirestoreEntity, Mapper } from '../../../@harmony';
import { SubscriptionEntity } from '../../../purchases';
import { Subscription } from '../../../purchases/domain/models/subscription.model';
import { TeamEntity } from '../../data/entities/team.entity';
import { Team } from '../models/team.model';
import { DEFAULT_TEAM_SETTINGS, TeamTrial } from '../..';
import { FormerUserEntityToFormerUserMapper } from '../../..';

// export class TeamToTeamEntityMapper implements Mapper<Team, FirestoreEntity<TeamEntity>> {
//   constructor(private readonly subscriptionMapper: Mapper<Subscription, SubscriptionEntity>) {}

//   public map(from: Team): FirestoreEntity<TeamEntity> {
//     return new FirestoreEntity(from.id, {
//       _version: 0,
//       additionalDomains: from.additionalDomains,
//       createdAt: Timestamp.fromDate(from.createdAt),
//       createdBy: from.createdBy,
//       domain: from.domain,
//       folder: from.folder,
//       industryId: from.industryId,
//       name: from.name,
//       ownerId: from.ownerId,
//       seatsOverride: from['seatsOverride'],
//       settings: from.settings,
//       subscription: from.subscription ? this.subscriptionMapper.map(from.subscription) : undefined,
//     });
//   }
// }

export class TeamEntityToTeamMapper implements Mapper<FirestoreEntity<TeamEntity>, Team> {
  private readonly formerUserMapper = new FormerUserEntityToFormerUserMapper();

  constructor(private readonly subscriptionMapper: Mapper<SubscriptionEntity, Subscription>) {}

  public map(from: FirestoreEntity<TeamEntity>): Team {
    return new Team(
      from.id,
      from.data.createdAt.toDate(),
      from.data.createdBy,
      from.data.folder,
      new Map(
        Object.entries(from.data.formerUsers ?? {}).map(([id, user]) => [
          id,
          this.formerUserMapper.map(new FirestoreEntity(id, user)),
        ]),
      ),
      from.data.industryId,
      from.data.metadata,
      from.data.name,
      from.data.ownerId,
      {
        ...DEFAULT_TEAM_SETTINGS,
        ...from.data.settings,
      },
      from.data.domain,
      from.data.additionalDomains,
      from.data.seatsOverride,
      from.data.subscription ? this.subscriptionMapper.map(from.data.subscription) : undefined,
      from.data.trial
        ? new TeamTrial(
            from.data.trial.startedAt.toDate(),
            from.data.trial.endsAt.toDate(),
            from.data.trial.duration,
            from.data.trial.seats,
          )
        : undefined,
      from.data.allowExternalUsersBulkImport,
    );
  }
}
